// extracted by mini-css-extract-plugin
module.exports = {"Ribbon":"Ribbon_Ribbon__3cWFz","RibbonHot":"Ribbon_RibbonHot__TRDog","RibbonSale":"Ribbon_RibbonSale__10WW6"};